import { render, staticRenderFns } from "./CounsellorAdd.vue?vue&type=template&id=b6a03108&"
import script from "./CounsellorAdd.vue?vue&type=script&lang=js&"
export * from "./CounsellorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports